module.exports = __webpack_public_path__ + "img/Bodice-Back-Jc-lace straps-Ka-Lb.3e6a38db.png";